import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { useUpdateTenant } from '@modules/common/hooks/useUpdateTenant';

interface ToggleTenantAutoApprovalOptions {
  onError?: () => void;
  onSuccess?: () => void;
}

export const useToggleTenantAutoApproval = (
  opts?: ToggleTenantAutoApprovalOptions,
) => {
  const { showSuccessNotification, showErrorNotification } =
    useNotificationContext();

  const { updateTenant, loading } = useUpdateTenant();

  const toggleAutoApproval = async (isAutoApprovalDisabled: boolean) => {
    try {
      await updateTenant({
        dashboardSettings: {
          isAutoApprovalDisabled,
        },
      });
      opts?.onSuccess?.();
      showSuccessNotification({
        contentComponent: `${
          isAutoApprovalDisabled ? 'Disabled' : 'Enabled'
        } Auto Approval`,
        props: {},
      });
    } catch {
      opts?.onError?.();
      showErrorNotification({
        contentComponent: `Failed to ${
          isAutoApprovalDisabled ? 'disable' : 'enable'
        } Auto Approval`,
        props: {},
      });
    }
  };

  return { toggleAutoApproval, isLoading: loading };
};
